export default Object.freeze({
  // COMMON_TREE_
  ALERT_DEPTH_IMPOSSIBLE: '최대 5단계까지 가능합니다.',
  ALERT_HTML_NOT_ALLOW: 'html 태그는 입력할 수 없습니다.',
  ALERT_NOT_SAVED: '저장되지 않은 내용이 있습니다. 화면을 이동하시겠습니까?',
  ALERT_NOT_FOUND_ITEM: '삭제할 아이템이 없습니다.',
  ALERT_DELETE_GROUP: '해당 그룹 삭제가 불가합니다.\n등록된 섹션을 삭제 또는 그룹 이동 후 다시 시도해주세요.',
  CONFIRM_BEFORE_DELETE_SAVE_GROUP: '선택한 그룹이 삭제됩니다.\n저장하시겠습니까?',
  CONFIRM_BEFORE_DELETE_SAVE_SECTION: '선택한 섹션과 등록된 배너 설정이 삭제됩니다.\n저장하시겠습니까?'
});
